<template>
  <table class="cell-intervals">
    <tbody>
      <tr
        v-for="(interval, ind) in intervalsLocalItems"
        :key="`cell-intervals-${ind}`"
        class="cell-intervals-table-row"
      >
        <td class="cell-intervals-table-cell" :class="{ 'cell-intervals-table-cell-required': !interval.isValid }">
          <div class="cell-intervals-item">
            <c-input
              v-model="interval.interval"
              class="cell-intervals-item-input"
              type="text"
              mask="##:## – ##:##"
              placeholder="00:00 – 00:00"
            />

            <c-button
              :class="{ 'cell-intervals-item-remove-hidden': intervalsLocalItems.length === 1 }"
              class="cell-intervals-item-remove"
              size="iconic"
              :icon="{ icon: 'close', color: 'secondary' }"
              @click="removeInterval(ind)"
            />
            <c-button
              v-if="ind === intervalsLocalItems.length - 1"
              class="cell-intervals-item-add"
              size="iconic"
              :icon="{ icon: 'plus', color: 'green' }"
              @click="addInterval"
            />
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import moment from "moment";
import Input from "@/components/controls2/Input";
import Button from "@/components/controls2/Button";

export default {
  name: "production-cell-intervals",
  components: {
    "c-input": Input,
    "c-button": Button,
  },
  props: ["record", "isDeliveryTab"],
  data() {
    return {
      intervalsLocalItems: [],
      notWatchOnLoad: true,
    };
  },
  watch: {
    intervalsLocalItems: {
      handler(newValue) {

        const today = moment().format("DD.MM.YYYY");
        let sumHoursWorked = 0;
        const intervals = [];

        let isValid = true; 
        newValue.forEach((item) => {
          if (item.interval.length === 0) {
            item.isValid = false;
            item.errorMessage = "Обязательное поле";
            return;
          }
          const start = item.interval.split("–")[0] !== undefined ? item.interval.split("–")[0] : "";
          const end = item.interval.split("–")[1] !== undefined ? item.interval.split("–")[1] : "";

          if (start.length < 6 || end.length < 6) {
            item.isValid = false;
            isValid = false;
            item.errorMessage = "Неверный формат интервала";
            return;
          }

          if (!moment(start, "H:mm").isValid() || !moment(end, "H:mm").isValid()) {
            item.isValid = false;
            isValid = false;
            item.errorMessage = "Неверный формат интервала";
            return;
          }

          const momentStart = moment(`${today} ${start.trim()}`, "DD-MM-YYYY HH:mm");
          let momentEnd = moment(`${today} ${end.trim()}`, "DD-MM-YYYY HH:mm");

          if (moment(momentStart) > moment(momentEnd)) {
            momentEnd = moment(moment().add(1, "d").format("DD-MM-YYYY") + end, "DD-MM-YYYY HH:mm");
          }
          sumHoursWorked += moment.duration(momentEnd.diff(momentStart)).asHours();

          item.isValid = true;
          item.errorMessage = "";
          intervals.push({start, end});
        });

        if (isValid && !this.notWatchOnLoad) {
          this.$parent.$parent.$parent.changeIntervals(this.record, intervals);
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.notWatchOnLoad = true;
    // console.log(this.record.working_interval.value, this.record.employee.value);
    this.intervalsLocalItems = this.record.working_interval.value.map((interval) => 
      // console.log(`${moment(interval.start).format("HH:mm")}–${moment(interval.finish).format("HH:mm")}`);
      ({
        interval: `${moment(interval.start).format("HH:mm")}–${moment(interval.finish).format("HH:mm")}`,
        isValid: true,
        errorMessage: "",
      }));
    setTimeout(()=> {this.notWatchOnLoad = false;}, 300);
    
  },
  methods: {
    addInterval() {
      this.intervalsLocalItems.push({ interval: "", isValid: false, errorMessage: "Обязательное поле" });
    },
    removeInterval(index) {
      this.intervalsLocalItems.splice(index, 1);
    },
  },
};
</script>
<style lang="scss" scoped>
.cell-intervals {
  min-width: 150px;
  display: flex;
  flex-direction: column;
  width: 100%;

  &-table-row {
    display: table-row !important;
  }

  &-table-cell {
    display: table-cell !important;
    position: static !important;
    background: inherit !important;

    &:hover {
      outline-style: solid;
      outline-width: 1px;
      outline-color: #0066ff;
      box-shadow: 0 0 10px rgba(0, 102, 255, 0.4);
    }

    &:before,
    &:after {
      display: none !important;
    }

    &-required {
      outline-style: solid !important;
      outline-width: 1px !important;
      outline-color: #ff238d !important;
      box-shadow: none !important;
    }
  }

  &-item {
    padding: 13px;
    min-height: 40px;
    display: flex;
    width: 100%;
    align-items: center;

    &-remove {
      margin-left: 3px;

      &-hidden {
        visibility: hidden;
        opacity: 0;
      }

      & ::v-deep svg {
        width: 11px !important;
        height: 11px !important;
      }
    }

    &-add {
      margin-left: auto !important;

      & ::v-deep svg {
        width: 14px !important;
        height: 14px !important;

        & path {
          fill: #12c971;
        }
      }

      & ::v-deep .c-button-icon {
        margin-left: -7px !important;
        margin-top: -6px !important;
      }
    }

    &-input {
      & ::v-deep .c-input-input {
        max-width: 80px !important;
        font-size: 13px;
        padding: 0 !important;
        background: inherit !important;

        &::placeholder {
          font-size: 13px;
        }
      }

      & ::v-deep .c-input-border {
        display: none;
      }
    }
  }
}
</style>
